import { Component, Input } from '@angular/core';
import { Event } from 'src/app/models/event/event.interface';
import { BackendCallService } from 'src/app/services/backend-call.service';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-collapsible-image-card',
  templateUrl: './collapsible-image-card.component.html',
  styleUrls: ['./collapsible-image-card.component.scss'],
})
export class CollapsibleImageCardComponent {
  collapsed = true;
  placeholder_image: string;

  @Input() color: string;
  @Input() event: Event;


  constructor(
    private config_service: ConfigService,

    public backend: BackendCallService,
  ) {
    this.placeholder_image = this.config_service.config.design.logos.placeholder;
  }
}
